import toCurrency from 'utils/toCurrency';

export const getColumnsCargos = () => [
  {
    titleText: 'Periodo',
    dataIndex: 'tipo_de_cargo',
    key: 'tipo_de_cargo',
    width: 150,
    render: (val) => val?.periodo_fiscal?.periodo,
  },
  {
    titleText: 'Descripción',
    dataIndex: 'descripcion',
    key: 'descripcion',
    width: 350,
    render: (val) => val,
  },
  {
    titleText: 'Importe Base',
    dataIndex: 'importe',
    key: 'importe',
    width: 150,
    align: 'right',
    render: (val) => toCurrency(val || 0),
  },
  {
    titleText: 'Recargo',
    dataIndex: 'recargo_total',
    key: 'recargo_total',
    width: 150,
    align: 'right',
    render: (val) => toCurrency(val || 0),
  },
  {
    titleText: 'Descuento',
    dataIndex: 'descuento_total',
    key: 'descuento_total',
    width: 150,
    align: 'right',
    render: (val) => toCurrency(val || 0),
  },
  {
    titleText: 'Actualización',
    dataIndex: 'actualizacion_total',
    key: 'actualizacion_total',
    width: 150,
    align: 'right',
    render: (val) => toCurrency(val || 0),
  },
  {
    titleText: 'Gasto',
    dataIndex: 'gasto_total',
    key: 'gasto_total',
    width: 150,
    align: 'right',
    render: (val) => toCurrency(val || 0),
  },
  {
    titleText: 'Importe Total',
    dataIndex: 'importe_total',
    key: 'importe_total',
    render: (val) => toCurrency(val || 0),
    align: 'right',
    width: 200,
  },
];

export const getColumnsGastos = (estadosGlobales) => [
  {
    titleText: 'Descripción',
    dataIndex: 'descripcion',
    key: 'descripcion',
    width: 350,
  },
  {
    titleText: 'Importe',
    dataIndex: 'importe',
    key: 'importe',
    width: 150,
    align: 'right',
    render: (val) => toCurrency(val || 0),
  },
  {
    titleText: 'Estado',
    dataIndex: 'estados_globales',
    key: 'estados_globales',
    width: 150,
    render: (val) => estadosGlobales?.find((e) => e.id === val)?.descripcion,
  },
];
